import React from 'react';
import { useDynamicReportsData } from 'models/kits';
import { LoaderSkeleton } from 'components/layout/KitRegistrationDashboard';
import { useTranslation } from 'react-i18next';
import { Tabs, PrevNext } from '../Common';
import { iDNA3ToOneCards } from '../iDNA3ToOne';
import { Result } from './Common';
import { profileToIcon, profileToUrl, adviceImages } from '../WeightControl';

const Fats = () => {
  const dietCard = iDNA3ToOneCards.filter((card) => {
    return 'diet' === card.id;
  })[0];

  let resultText = '';
  let value = '';
  let advice = '';

  const { i18n } = useTranslation();

  const data = useDynamicReportsData(i18n.language);
  if (null == data || 0 === data.length) {
    return <LoaderSkeleton />;
  }

  const sensProfiles = data[0].value.categories.filter((currData) => {
    return [ 'NCAT3', 'NCAT6', 'NCAT12', 'NCAT9', 'NCAT19', 'NCAT8' ].includes(currData.ID);
  }).map((filtered) => {
    let iconPath = '';
    let url = '';
    const prefix = 'τα';
    let adviceImage;
    const description = 'NCAT12_description';

    if ('NCAT3' === filtered.ID) {
      iconPath = profileToIcon.carbohydrates;
      url = profileToUrl.carbohydrates;
    } else if ('NCAT6' === filtered.ID) {
      iconPath = profileToIcon.proteins;
      url = profileToUrl.proteins;
    } else if ('NCAT12' === filtered.ID) {
      iconPath = profileToIcon.fats;
      url = profileToUrl.fats;
      resultText = filtered.genetic_profile_text;
      value = filtered.result;
      advice = {
        advice_start: filtered.advice_start,
        advice_points_pre: filtered.advice_points_pre,
        advice_points: filtered.advice_points,
        advice_points_post: filtered.advice_points_post,
        advice_end: filtered.advice_end,
      };
      adviceImage = adviceImages.fats;
    } else if ('NCAT9' === filtered.ID) {
      iconPath = profileToIcon.preferenceForSweetTaste;
      url = profileToUrl.preferenceForSweetTaste;
    } else if ('NCAT19' === filtered.ID) {
      iconPath = profileToIcon.biologicalClock;
      url = profileToUrl.biologicalClock;
    } else if ('NCAT8' === filtered.ID) {
      iconPath = profileToIcon.eatingSnacksBetweenMeals;
      url = profileToUrl.eatingSnacksBetweenMeals;
    }

    return { ...filtered, icon: iconPath, url, prefix, adviceImage, description };
  });

  return (
    <div>
      <Tabs />
      <PrevNext options={ dietCard } activePage='weightManagement' />
      <Result
        sensitivityProfiles={ sensProfiles }
        activeProfile='Λιπαρά'
        activeColor={ dietCard.color }
        resultText={ resultText }
        value={ value }
        advice={ advice }
        adviceImage={ adviceImages.fats }
      />
    </div>
  );
};

export default Fats;
